import { render } from "./EditPlatFormVideo.vue?vue&type=template&id=593280ac&scoped=true"
import script from "./EditPlatFormVideo.vue?vue&type=script&lang=js"
export * from "./EditPlatFormVideo.vue?vue&type=script&lang=js"

import "./EditPlatFormVideo.vue?vue&type=style&index=0&id=593280ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593280ac"]])

export default __exports__